import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "./Login";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell title="Set a New Password" subtitle="Choose a strong password for your account.">
      {!token ? (
        <div className="bg-red-500/10 border border-red-500/40 text-red-300 text-sm rounded-xl px-4 py-3" data-testid="reset-no-token">
          This reset link is missing its token. Please request a new one.
        </div>
      ) : done ? (
        <div className="bg-emerald-500/10 border border-emerald-500/40 text-emerald-300 text-sm rounded-xl px-4 py-3" data-testid="reset-success">
          Password updated. Redirecting to sign in…
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {error && <div className="bg-red-500/10 border border-red-500/40 text-red-300 text-sm rounded-xl px-4 py-3" data-testid="reset-error">{error}</div>}
          <div>
            <Label htmlFor="rp-password">New Password (min 8 characters)</Label>
            <Input id="rp-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-navy-base border-white/15 text-white mt-1" data-testid="reset-password-input" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold transition-colors" data-testid="reset-submit-btn">
            {submitting ? "Updating…" : "Update Password"}
          </Button>
        </form>
      )}
      <p className="text-sm text-slate-400 mt-6 text-center">
        <Link to="/login" className="text-orange-400 hover:text-orange-300 font-medium transition-colors" data-testid="reset-back-login">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
